import { request } from '@services'

export const state = {
  loading: false,
  data: null,
  errors: null,
}

export const getters = {
  getAdminList(state) {
    return state.data
  },
}

export const mutations = {
  SET_ADMIN_LIST_REQUESTED(state) {
    state.loading = true
  },
  SET_ADMIN_LIST_RECEIVED(state, newData) {
    state.loading = false
    state.data = newData
    state.errors = null
  },
  SET_ADMIN_LIST_RECEIVED_FAILED(state, error) {
    state.loading = false
    state.errors = error
  },
  RESET_ADMIN_LIST(state) {
    state.loading = false
    state.data = null
    state.errors = null
  },
}

export const actions = {
  async fetchingAdminList({ commit }, params) {
    commit('SET_ADMIN_LIST_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/admin/list/',
        payload: { ...params },
      })
      commit('SET_ADMIN_LIST_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_ADMIN_LIST_RECEIVED_FAILED', error)
    }
  },
  resetAdminList({ commit }) {
    commit('RESET_ADMIN_LIST')
  },
}
